module.exports = __webpack_public_path__ + "media/images/shared/three-lines-bcd74530fcb40d600d77c0df4fa53e9d.svg";